import { render, staticRenderFns } from "./publicCvView.vue?vue&type=template&id=fb82562e&scoped=true"
import script from "./publicCvView.vue?vue&type=script&lang=js"
export * from "./publicCvView.vue?vue&type=script&lang=js"
import style0 from "./publicCvView.vue?vue&type=style&index=0&id=fb82562e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb82562e",
  null
  
)

export default component.exports